import { render, staticRenderFns } from "./Odeapast.vue?vue&type=template&id=0e4a94d5&"
import script from "./Odeapast.vue?vue&type=script&lang=js&"
export * from "./Odeapast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports